<script>
import numeral from 'numeral'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'
import { AppTracker } from '@/components/ui/tracker'

export default {
  functional: true,

  props: {
    name: {
      type: String,
      default: ''
    },

    period: {
      type: Array,
      default: null
    },

    amount: {
      type: Number,
      default: 0
    },

    importAmount: {
      type: Number,
      default: 0
    },

    exportAmount: {
      type: Number,
      default: 0
    },

    loading: {
      type: Boolean,
      default: false
    },

    mq: {
      type: String,
      default: ''
    },

    unit: {
      type: String,
      default: ''
    },

    format: {
      type: String,
      default: '0,0'
    }
  },

  render(h, { data, props, listeners, $style }) {
    const InlineTracker = ({ props }) => {
      return (
        <div class={$style.inlineTracker}>
          <el-row
            type="flex"
            gutter={16}
            align="middle"
            style={{ flexWrap: 'wrap' }}
          >
            <el-col span={null} xs={24}>
              {props.label}
            </el-col>
            <el-col
              span={null}
              xs={24}
              class={$style.value}
              style={{ flex: '1' }}
            >
              {numeral(props.value).format(props.format)}
            </el-col>
            <el-col span={null} xs={24} class={$style.unit}>
              {props.unit}
            </el-col>
          </el-row>
        </div>
      )
    }

    return (
      <el-card
        {...data}
        {...{ directives: [{ name: 'loading', value: props.loading }] }}
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
      >
        <el-row type="flex" gutter={32} style={{ flexWrap: 'wrap' }}>
          <el-col sm={12} style={{ display: 'flex', flexDirection: 'column' }}>
            <h1
              style={{
                fontSize: '1.5rem',
                margin: '0 0 auto',
                paddingBottom: '1rem'
              }}
            >
              {props.name}
            </h1>
            <el-date-picker
              value={props.period}
              type="daterange"
              startPlaceholder="Start Date"
              endPlaceholder="End Date"
              class={elementUiStyles.dateRange}
              style={{ width: '100%', height: '3.5rem' }}
              onInput={value => {
                listeners['update:period'] && listeners['update:period'](value)
              }}
              onChange={value => {
                listeners['change:period'] && listeners['change:period'](value)
              }}
            />
          </el-col>
          <el-col
            sm={12}
            style={{
              marginTop: ['sm'].includes(props.mq) ? '1rem' : undefined
            }}
          >
            <InlineTracker
              label="จำนวนในคลังสินค้า"
              value={props.amount}
              unit={props.unit}
              format={props.format}
            />
            <el-row
              type="flex"
              gutter={16}
              align="middle"
              style={{ flexWrap: 'wrap', marginTop: '1rem' }}
            >
              <el-col
                span={null}
                style={{
                  fontWeight: 'bold',
                  flexBasis: ['sm', 'md'].includes(props.mq)
                    ? '100%'
                    : undefined
                }}
              >
                สรุป
              </el-col>
              <el-col
                span={null}
                style={{
                  flex: '1',
                  marginTop: ['sm', 'md'].includes(props.mq)
                    ? '0.5rem'
                    : undefined
                }}
              >
                <div
                  style={
                    !['sm'].includes(props.mq) && { paddingLeft: '0.5rem' }
                  }
                >
                  <el-row type="flex" gutter={16} style={{ flexWrap: 'wrap' }}>
                    <el-col sm={12} class={$style.trackerCol}>
                      <AppTracker
                        label="สินค้าเข้า"
                        value={props.importAmount}
                        unit={props.unit}
                        format={props.format}
                      />
                    </el-col>
                    <el-col sm={12} class={$style.trackerCol}>
                      <AppTracker
                        label="สินค้าออก"
                        value={props.exportAmount}
                        unit={props.unit}
                        format={props.format}
                      />
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
    )
  }
}
</script>

<style lang="scss" module>
.dateInput {
  :global(.el-input__inner) {
    height: 3.5rem;
    line-height: 3.5rem;
  }
}

.inlineTracker {
  padding: 0.5rem;
  background-color: $--background-color-base;
  border: 1px solid $--border-color-base;
  font-weight: bold;
  font-size: 1rem;
  color: $--color-text-regular;

  .value {
    font-size: 1.75rem;
    color: $--color-text-primary;
    text-align: center;
  }

  .unit {
    text-align: right;
  }
}

.trackerCol {
  @media (min-width: $--sm) {
    border-left: 2px solid $--border-color-base;
  }
}
</style>
